import { createStyles } from "@mantine/emotion";

export const useStylesTriggerHelp = createStyles((theme) => ({
  trigger: {
    position: "fixed",
    right: theme.spacing.triggerHelp.position.right,
    bottom: theme.spacing.triggerHelp.position.bottom,
    boxShadow: "0 3px 3px rgba(0, 0, 0, 0.161)",
    padding: theme.spacing.triggerHelp.padding.main,
    borderRadius: theme.spacing.triggerHelp.borderRadius,
    backgroundColor: theme.customBackgrounds.white,
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: theme.spacing.triggerHelp.arrow.bottom,
      left: theme.spacing.triggerHelp.arrow.left,
      width: "0",
      height: "0",
      borderLeft: `${theme.spacing.triggerHelp.arrow.size} solid transparent`,
      borderRight: `${theme.spacing.triggerHelp.arrow.size} solid transparent`,
      borderTop: `${theme.spacing.triggerHelp.arrow.size} solid ${theme.customBackgrounds.white}`,
    },
    ".text": {
      fontFamily: theme.headings.fontFamily.light,
      fontSize: "1em",
    },
    ".textBold": {
      fontFamily: theme.headings.fontFamily.medium,
      fontSize: "1em",
    },
    ".mantine-Switch-track": {
      backgroundColor: "rgba(237,240,229,0.4)",
      borderColor: "rgba(112,112,112,0.2)",
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: theme.spacing.triggerHelp.switch.margin.top,
      marginBottom: theme.spacing.triggerHelp.switch.margin.bottom,
    },
    ".mantine-Switch-track .mantine-Switch-thumb": {
      backgroundColor: theme.customColors.triggerHelp,
      borderColor: theme.customColors.triggerHelp,
    },

    "input:checked + .mantine-Switch-track .mantine-Switch-thumb": {
      backgroundColor: theme.customBackgrounds.greenLight,
      borderColor: theme.customBackgrounds.greenLight,
    },
  },
}));
